export default "__VITE_ASSET__blGCItgH__"